var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommentUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7072 9.87899L13.4142 5.58599C13.0392 5.21105 12.5305 5.00042 12.0002 5.00042C11.4699 5.00042 10.9613 5.21105 10.5862 5.58599L6.29321 9.87899L7.70721 11.293L11.0002 7.99999V19H13.0002V7.99999L16.2932 11.293L17.7072 9.87899Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentUpload);
export default __webpack_public_path__ + "static/media/comment-upload.db4bf0e8f580c5996464edb2e656205f.svg";
export { ForwardRef as ReactComponent };